import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import _ from "lodash"

const FAQs = [
  {
    Q: 'Are there any costs for using Golden Gate Pharmacy’s services?',
    A: 'No, you are only responsible for the cost of the medication.',
  },
  {
    Q: 'Does Golden Gate Pharmacy do titrations?',
    A: 'Yes we do.',
  },
  {
    Q: 'How will my medication be packaged?',
    A: 'However you prefer. You have the option of having the medication packaged in a vial, pill pack, or bubble packed.',
  },
  {
    Q: 'Do you offer overnight shipping?',
    A: 'Yes we have options to ship overnight should there be an emergency.',
  },
  {
    Q: 'Does Golden Gate Pharmacy deliver medication to Southern California?',
    A: 'Golden Gate Pharmacy currently services hundreds of patients across all of California. ',
  },
  {
    Q: 'How will my patient get his/her medication?',
    A: 'Golden Gate Pharmacy will ship the medication via FedEx to the location of the patient’s choice. Tracking will be provided to the patients.',
  },
  {
    Q: 'Does the medication need to be reordered?',
    A: 'No, medication will automatically be filled and shipped by Golden Gate Pharmacy. However, this will only take place if there is a valid lab on file.',
  },
  {
    Q: 'What if my patient has multiple medications?',
    A: 'The patient has the option of transferring all of his/her other prescriptions to Golden Gate Pharmacy should the patient want his/her medication delivered with Clozapine.',
  },
  {
    Q: 'How do patients pay for his/her medication?',
    A: 'At the beginning of the month he/she will receive an invoice for the medication.',
  },
]

const FAQ = () => (
  <Layout>
    <SEO title="Frequently Asked Questions" />
    <h1>Frequently Asked Questions</h1><br />
    {
      _.map(FAQs, (qa) => {
        return (<div key={qa.question}>
          <div className='question'>{qa.Q}</div>
          <div className='answer'>{qa.A}</div>
        </div>
        )
      })
    }

  </Layout>
)

export default FAQ
